import { Component, output } from '@angular/core'

import type { DateRange } from '../components/components/filter-date-range'
import { FilterDateRangeAccordion } from '../components/filter-accordion/filter-date-range-accordion'
import { FilterDateRangeDialog } from '../components/filter-dialog/filter-date-range-dialog'

@Component({
  selector: 'dhp-date-range-filter',
  templateUrl: './date-range-filter.html',
  imports: [FilterDateRangeDialog, FilterDateRangeAccordion],
})
export class DateRangeFilter {
  //region Outputs
  // The date range to filter on, with a from and to date.
  protected filterOutput = output<DateRange | null>()
  //endregion Outputs

  //region Properties
  protected readonly filterName = 'common.filter.dateRange.rulingDate'
  //endregion Properties
}
